import type { JSX, ReactNode } from 'react';

import { CarouselDots } from './components/CarouselDots';
import { NavigationArrows } from './components/NavigationArrows';
import { useCardCarousel } from './hooks/useCardCarousel';

type CardCarouselProps = {
	items: Array<{
		key: string;
		component: ReactNode;
	}>;
};
export function CardCarousel({ items }: CardCarouselProps): JSX.Element {
	const {
		scrollContainerRef,
		activeIndex,
		canScrollLeft,
		canScrollRight,
		handleScrollLeft,
		handleScrollRight,
		setItemRef,
	} = useCardCarousel({ itemCount: items.length });

	return (
		<div className="relative flex flex-col gap-5 md:gap-3">
			<div className="relative">
				<NavigationArrows
					canScrollLeft={canScrollLeft}
					canScrollRight={canScrollRight}
					onScrollLeft={handleScrollLeft}
					onScrollRight={handleScrollRight}
				/>
				<div
					ref={scrollContainerRef}
					className="flex w-full snap-x snap-mandatory flex-row gap-3 overflow-x-auto md:gap-12"
					sx={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
				>
					{items.map(({ component, key }, index) => (
						<div key={key} ref={setItemRef(index)} className="flex-shrink-0 snap-center md:min-w-full">
							{component}
						</div>
					))}
				</div>
			</div>
			<CarouselDots totalItems={items.length} activeIndex={activeIndex} />
		</div>
	);
}
